<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <form class="form" [formGroup]="model" (ngSubmit)="submit()">
            <div class="row">
                <div class="col-12">
                    <h1 class="title-default">Perfis</h1>
                    <p class="welcome-message">
                        <button mat-icon-button type="button" (click)="cancelar()">
                            <mat-icon>arrow_back</mat-icon>
                        </button>
                        Configurações e preferências do cadastro de perfis.
                    </p>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-sm-6 col-md-4">
                    <mat-form-field appearance="outline">
                        <mat-label>Nome</mat-label>
                        <input matInput type="text" formControlName="nome">
                        @if (model.get('nome')?.invalid) {
                        <mat-error>Informe o nome</mat-error>
                        }
                    </mat-form-field>
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                    <mat-form-field appearance="outline">
                        <mat-label>Descrição</mat-label>
                        <input matInput type="text" formControlName="descricao">
                    </mat-form-field>
                </div>
            </div>

            <!-- Permissões -->
            <div class="row">
                <cdk-accordion class="profile-register-accordion">
                    @for (itemModulo of listaModuloPerfil; track $index; let index = $index) {
                    @if (itemModulo.moduloPermitido || this.isMaster) {
                    <cdk-accordion-item #accordionItemModule="cdkAccordionItem" class="profile-register-accordion-item"
                        role="button" tabindex="0" [attr.id]="'accordion-header-' + index"
                        [attr.aria-expanded]="accordionItemModule.expanded"
                        [attr.aria-controls]="'accordion-body-' + index">
                        <div [ngClass]="{'profile-register-accordion-item-header-expanded' : accordionItemModule.expanded, 'disabled-module' : !itemModulo.moduloPermitido}"
                            class="profile-register-accordion-item-header"
                            (click)=" !itemModulo.moduloPermitido ? openModal(): accordionItemModule.toggle()">
                            <span class="module-header-title">
                                {{ itemModulo.nomeModulo }}
                                @if (itemModulo.moduloPermitido) {
                                <span class="permission-count-badge"
                                    [class.permission-count-badge-expanded]="accordionItemModule.expanded">
                                    {{ getModuloSelecionadas(itemModulo) }}/{{ getModuloTotal(itemModulo) }} permissões
                                </span>
                                }
                            </span>
                            @if (itemModulo.moduloPermitido) {
                            <span
                                [ngClass]="{'profile-register-accordion-item-description-expanded': accordionItemModule.expanded}"
                                class="profile-register-accordion-item-description">
                                Clique para {{ accordionItemModule.expanded ? 'fechar' : 'abrir' }}
                            </span>
                            }
                        </div>
                        <div class="profile-register-accordion-item-body" role="region"
                            [style.display]="accordionItemModule.expanded ? '' : 'none'"
                            [attr.id]="'accordion-body-' + index" [attr.aria-labelledby]="'accordion-header-' + index">
                            @for (itemFuncionalidade of itemModulo.listaFuncionalidade; track $index; let
                            indexFuncionalidade = $index) {
                            <div class="feature-content"
                                [ngClass]="{'feature-border': indexFuncionalidade + 1 < itemModulo.listaFuncionalidade.length}">
                                <div class="feature-content-header">
                                    <span>{{itemFuncionalidade.nome}}</span>
                                    @if (itemFuncionalidade.listaPermissao.length > 1) {
                                    <mat-slide-toggle class="app-toggle-compact select-all-toggle"
                                        [checked]="isFuncionalidadeTotalmenteMarcada(itemFuncionalidade)"
                                        (change)="toggleFuncionalidadeEmMassa(itemFuncionalidade)">
                                        Marcar tudo
                                    </mat-slide-toggle>
                                    }
                                </div>
                                <div class="feature-content-roles">
                                    @for (itemPermissao of itemFuncionalidade.listaPermissao; track $index) {
                                    <mat-checkbox class="role-checkbox" [checked]="itemPermissao.selecionado"
                                        (change)="itemPermissao.selecionado = !itemPermissao.selecionado">
                                        @if (parsePermissaoNome(itemPermissao.nome); as parsed) {
                                        <span class="permission-name">
                                            @if (parsed.prefixo) {
                                            <span class="permission-name-prefix">{{ parsed.prefixo }}</span>
                                            }
                                            <span class="permission-name-action">{{ parsed.acao }}</span>
                                        </span>
                                        }
                                    </mat-checkbox>
                                    }
                                </div>
                            </div>
                            }
                        </div>
                    </cdk-accordion-item>
                    }
                    }
                </cdk-accordion>
            </div>
        </form>

        <!-- Restrições de Acesso -->
        <div class="restriction-section">
            <h1 class="subtitle-default">Restrições de Acesso</h1>
            <p class="restriction-description">
                Configure restrições de IP e horário para usuários com este perfil. Usuários master não são afetados por
                estas restrições.
            </p>

            <!-- Permissão por IP -->
            <div class="restriction-card">
                <div class="restriction-card-header">
                    <div class="restriction-card-title">
                        <mat-icon class="restriction-icon">router</mat-icon>
                        <span>Permissão por IP</span>
                        @if (possuiRestricaoIp) {
                        <span class="restriction-badge">
                            <mat-icon class="badge-icon">lock</mat-icon>
                            {{listaIpRestrito.length}} IP(s) configurado(s)
                        </span>
                        }
                    </div>
                    <p class="restriction-card-description">
                        Permite o acesso apenas dos endereços IP informados. Deixe vazio para não restringir por IP.
                    </p>
                </div>

                <div class="ip-input-row">
                    <mat-form-field appearance="outline" class="ip-input-field">
                        <mat-label>Endereço IP</mat-label>
                        <input matInput type="text" [(ngModel)]="novoIp" placeholder="Ex: 192.168.1.1"
                            (keyup.enter)="adicionarIp()">
                        <mat-icon matSuffix
                            matTooltip="Informe o endereço IP completo que terá acesso permitido. Ex: 192.168.1.100">
                            info_outline
                        </mat-icon>
                    </mat-form-field>
                    <button mat-stroked-button type="button" class="btn-secondary btn-add-ip" (click)="adicionarIp()">
                        <mat-icon>add</mat-icon>
                        Adicionar IP
                    </button>
                </div>

                @if (listaIpRestrito.length > 0) {
                <div class="ip-list">
                    @for (ip of listaIpRestrito; track $index) {
                    <div class="ip-chip">
                        <mat-icon class="ip-chip-icon">computer</mat-icon>
                        <span>{{ip}}</span>
                        <button mat-icon-button type="button" class="ip-remove-btn" (click)="removerIp(ip)"
                            matTooltip="Remover IP">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                    }
                </div>
                }

                @if (listaIpRestrito.length === 0) {
                <p class="restriction-empty">
                    Nenhum IP configurado — acesso liberado para qualquer IP.
                </p>
                }
            </div>

            <!-- Permissão por Horário -->
            <div class="restriction-card">
                <div class="restriction-card-header">
                    <div class="restriction-card-title">
                        <mat-icon class="restriction-icon">schedule</mat-icon>
                        <span>Permissão por Horário</span>
                        @if (possuiRestricaoHorario) {
                        <span class="restriction-badge">
                            <mat-icon class="badge-icon">lock</mat-icon>
                            Horários configurados
                        </span>
                        }
                    </div>
                    <p class="restriction-card-description">
                        Permite o acesso apenas dentro dos horários definidos para cada dia da semana. Dias não
                        habilitados não terão acesso permitido naquele dia.
                    </p>
                </div>

                <div class="schedule-group">
                    <h3 class="schedule-group-title">Dias da semana</h3>
                    <div class="schedule-cards">
                        @for (dia of diasSemana; track $index) {
                        <div class="schedule-day-card">
                            <div class="schedule-day-header">
                                <span class="schedule-day-name">{{ dia.nome }}</span>
                                <mat-slide-toggle [(ngModel)]="dia.habilitado"
                                    (ngModelChange)="onDayToggled(dia)"></mat-slide-toggle>
                            </div>

                            @if (dia.habilitado) {
                            <div class="schedule-intervals">
                                @for (intervalo of dia.intervalos; track $index; let i = $index) {
                                <div class="interval-row">
                                    <mat-form-field appearance="outline" class="time-field">
                                        <mat-label>Início</mat-label>
                                        <input matInput type="time" [(ngModel)]="intervalo.horaInicio">
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" class="time-field">
                                        <mat-label>Fim</mat-label>
                                        <input matInput type="time" [(ngModel)]="intervalo.horaFim">
                                    </mat-form-field>

                                    <span class="interval-row-actions">
                                        @if (i > 0) {
                                        <button mat-icon-button type="button"
                                            class="interval-icon-button interval-remove"
                                            (click)="removerIntervalo(dia, i)" matTooltip="Remover intervalo"
                                            [disabled]="dia.intervalos.length <= 1">
                                            <mat-icon>close</mat-icon>
                                        </button>
                                        }
                                    </span>
                                </div>
                                }

                                <button mat-stroked-button type="button" class="btn-add-interval"
                                    (click)="adicionarIntervalo(dia)" matTooltip="Adicionar intervalo">
                                    <mat-icon>add</mat-icon>
                                    Adicionar intervalo
                                </button>
                            </div>
                            }

                            @if (!dia.habilitado) {
                            <p class="schedule-day-disabled-text">
                                Ative para configurar intervalos de acesso.
                            </p>
                            }
                        </div>
                        }
                    </div>
                </div>

                <div class="schedule-group">
                    <h3 class="schedule-group-title">Fim de semana</h3>
                    <div class="schedule-cards">
                        @for (dia of diasFimDeSemana; track $index) {
                        <div class="schedule-day-card">
                            <div class="schedule-day-header">
                                <span class="schedule-day-name">{{ dia.nome }}</span>
                                <mat-slide-toggle [(ngModel)]="dia.habilitado"
                                    (ngModelChange)="onDayToggled(dia)"></mat-slide-toggle>
                            </div>

                            @if (dia.habilitado) {
                            <div class="schedule-intervals">
                                @for (intervalo of dia.intervalos; track $index; let i = $index) {
                                <div class="interval-row">
                                    <mat-form-field appearance="outline" class="time-field">
                                        <mat-label>Início</mat-label>
                                        <input matInput type="time" [(ngModel)]="intervalo.horaInicio">
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" class="time-field">
                                        <mat-label>Fim</mat-label>
                                        <input matInput type="time" [(ngModel)]="intervalo.horaFim">
                                    </mat-form-field>

                                    <span class="interval-row-actions">
                                        @if (i > 0) {
                                        <button mat-icon-button type="button"
                                            class="interval-icon-button interval-remove"
                                            (click)="removerIntervalo(dia, i)" matTooltip="Remover intervalo"
                                            [disabled]="dia.intervalos.length <= 1">
                                            <mat-icon>close</mat-icon>
                                        </button>
                                        }
                                    </span>
                                </div>
                                }

                                <button mat-stroked-button type="button" class="btn-add-interval"
                                    (click)="adicionarIntervalo(dia)" matTooltip="Adicionar intervalo">
                                    <mat-icon>add</mat-icon>
                                    Adicionar intervalo
                                </button>
                            </div>
                            }

                            @if (!dia.habilitado) {
                            <p class="schedule-day-disabled-text">
                                Ative para configurar intervalos de acesso.
                            </p>
                            }
                        </div>
                        }
                    </div>
                </div>

                @if (!possuiRestricaoHorario) {
                <p class="restriction-empty">
                    Nenhum horário configurado — acesso liberado em qualquer horário.
                </p>
                }
            </div>
        </div>
    </div>
</div>

<app-footer-action [isLoadingSalvar]="_isLoading" (cancelar)="cancelar()" (salvar)="submit()"></app-footer-action>